import React from "react";
import { useIntl } from "react-intl";

import { ReactComponent as FireIcon } from "src/images/fire.svg";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";
import Tooltip from "../Tooltip/Tooltip";

import "./ViralPostsIndicator.scss";

interface Props {
  er: number | string;
  erWithVirals?: number | string | null;
  viralPostsCount?: number | null;
  erPostsCount?: number | null;
  alignRight?: boolean;
}

export const hasViralPosts = (viralPostsCount?: number | null) =>
  Number(viralPostsCount) > 0;

export const VIRAL_TOOLTIP_CLASS = "viral-tooltip";

export function ViralTooltipContent({
  title,
  children,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <span className="viral-tooltip__content">
      <span className="viral-tooltip__title">{title}</span>
      <span className="viral-tooltip__body">{children}</span>
    </span>
  );
}

function ViralPostsIndicator({
  er,
  erWithVirals,
  viralPostsCount,
  erPostsCount,
  alignRight,
}: Props) {
  const intl = useIntl();

  if (!hasViralPosts(viralPostsCount)) return null;

  return (
    <Tooltip
      alignRight={alignRight}
      className="viral-posts-indicator"
      contentClassName={VIRAL_TOOLTIP_CLASS}
      content={
        <ViralTooltipContent
          title={
            <IDHFormattedMessage
              id="ws_viral_posts_excluded"
              defaultMessage="Viral posts excluded"
            />
          }
        >
          <span className="viral-tooltip__line">
            <IDHFormattedMessage
              id="ws_er_without_virals"
              defaultMessage="Without virals:"
            />
            &nbsp;{er}%
          </span>
          {erWithVirals !== null && erWithVirals !== undefined && (
            <span className="viral-tooltip__line">
              <IDHFormattedMessage
                id="ws_er_with_virals"
                defaultMessage="With virals:"
              />
              &nbsp;{erWithVirals}%
            </span>
          )}
          {erPostsCount ? (
            <span className="viral-tooltip__line">
              {intl.formatMessage(
                {
                  id: "ws_viral_posts_excluded_count",
                  defaultMessage:
                    "{viralPostsCount} of {postsCount} posts excluded",
                },
                { viralPostsCount, postsCount: erPostsCount },
              )}
            </span>
          ) : null}
        </ViralTooltipContent>
      }
    >
      <FireIcon className="viral-posts-indicator__icon" />
    </Tooltip>
  );
}

export default ViralPostsIndicator;
